import { render } from "./multi-dragon-tiger-bet-view.vue?vue&type=template&id=bdb4dd48&scoped=true"
import script from "./multi-dragon-tiger-bet-view.vue?vue&type=script&lang=js"
export * from "./multi-dragon-tiger-bet-view.vue?vue&type=script&lang=js"

import "./multi-dragon-tiger-bet-view.vue?vue&type=style&index=0&id=bdb4dd48&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb4dd48"]])

export default __exports__